// eslint-disable-next-line no-unused-vars
const DEBUG = process.env.NODE_ENV !== 'production'

let config
if (false) { // DEBUG) {
  config = {
    PRIMARY_COLOR: '#D32B19',
    COLOR_BUTTON_ON: 'white',
    COLOR_BUTTON_OFF: '#787D83',
    ALGOLIA_APP_ID: 'O6J688Z7WM',
    ALGOLIA_SEARCH_KEY: '71190b9eccd64b71c77879639f0d6768',
    ALGOLIA_INDEX_NAME: 'resultados-test',
    FIREBASE_APPID: '1:1054692916501:android:83ab318fb5c11918',
    FIREBASE_APIKEY: 'AIzaSyBT56GpVesmtDKzos4wZvBym4LSjGY-Fkw',
    FIREBASE_PROJECTID: 'resultados-test',
    COLORES_FAVORITOS: ['#a83c94', '#13adb9', '#d32b19', '#2ca030', '#f39a0a', '#f46200'],
    MAP_LAYER: 'https://wms.ccnorte.es/tms/cartocb/{z}/{x}/{y}.jpg',
    // MAP_LAYER: 'https://wms.ccnorte.es/tms/esri-gray/{z}/{x}/{y}.jpg',
    // MAP_LAYER: 'https://wms.ccnorte.es/tms/hydda-full/{z}/{x}/{y}.png',
    NUMERO_MAXIMO_RANKINGS: 20,
    NUMERO_MAXIMO_RESULTADOS: 100,
    FCM_SENDER_ID: '1054692916501',
    FCM_PUBLIC_KEY: 'BCQNBwsh30KnZxe4oalTG114hatr-zoB8gDxSU3HJ1F3x1K4hx3CNmcZjt038VoF04KbUu697VDCC-wKAAnWMk8'
  }
} else {
  config = {
    PRIMARY_COLOR: '#D32B19',
    COLOR_BUTTON_ON: 'white',
    COLOR_BUTTON_OFF: '#787D83',
    ALGOLIA_APP_ID: 'H8NLPBMRB4',
    ALGOLIA_SEARCH_KEY: 'cdbf4f524771f6b70f77bf4e51c2aca3',
    ALGOLIA_INDEX_NAME: 'resultados-b',
    FIREBASE_APIKEY: 'AIzaSyBdAHkjo4ZMuEB0in0xMi6OBLuccvxAr8Q',
    FIREBASE_APPID: '1:815099075430:android:d2871b8a7afeef5b',
    FIREBASE_PROJECTID: 'resultados-ccn',
    COLORES_FAVORITOS: [ '#a83c94', '#13adb9', '#d32b19', '#2ca030', '#f39a0a', '#f46200' ],
    // MAP_LAYER: 'https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png',
    // MAP_LAYER: 'https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png',
    // MAP_LAYER: 'https://tiles.stadiamaps.com/tiles/outdoors/{z}/{x}/{y}{r}.png',
    // MAP_LAYER: 'https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}{r}.png',
    // MAP_LAYER: 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png',
    MAP_LAYER: 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png',
    // MAP_LAYER: 'https://wms.ccnorte.es/tms/cartocb/{z}/{x}/{y}.jpg',
    // MAP_LAYER: 'https://wms.ccnorte.es/tms/esri-gray/{z}/{x}/{y}.jpg',
    // MAP_LAYER: 'https://wms.ccnorte.es/tms/hydda-full/{z}/{x}/{y}.png',
    NUMERO_MAXIMO_RANKINGS: 20,
    NUMERO_MAXIMO_RESULTADOS: 100,
    FCM_SENDER_ID: '815099075430',
    WS_URL: 'wss://live3.resultados.live',
    API_URL: 'https://next3.resultados.live',
    FCM_PUBLIC_KEY: 'BJPpNdBoZbdlUjKkQpca9X6SWXpzn1LbxUBJJbvkvTyoUGnHqchKd3LVIe50Z2eO5sRlrl_-sMWgEZTzjQbuskM'
  }
}

export default config
